<template>
    <section class="bottom-container">
        <section @click="leftFunc">
            <span>{{leftLabel}}</span>
            <b-icon-eraser></b-icon-eraser>
        </section>
        <section @click="rightFunc">
            <span >{{rightLabel}}</span>
            <b-icon-plus-circle v-if="rightIcon == 'add'"></b-icon-plus-circle>
            <b-icon-arrow-return-left v-if="rightIcon == 'undo'"></b-icon-arrow-return-left>
        </section>
    </section>
</template>
<script>
export default {
    name: "BottomActions",
    props: {
        leftFunc: Function,
        rightFunc: Function,
        leftLabel: String,
        rightLabel: String,
        rightIcon: String
    }
}
</script>
<style scoped>
.bottom-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem;
    width: 100%;
}

.bottom-container section{
    display: flex;
    align-items: center;
    column-gap: 0.3rem;
    color: #FF5F00;
    cursor: pointer;
    font-weight: 500;
}
</style>